import { useEffect } from 'react';
import useRemoteConfig from './useRemoteConfig';
import { fetchConfig } from '../firebase';

/**
 * Reads the `sso_restricted_domains` Firebase Remote Config key.
 * Expected value: a JSON array of domain strings, e.g. ["acme.com", "corp.org"]
 *
 * Fetches a fresh value from Firebase on every mount so marketing changes
 * are reflected immediately without waiting for the default 12-hour cache.
 *
 * Returns a helper that tells you whether a given email address belongs to
 * an SSO-only domain.
 */
function useSSORestrictedDomains() {
  useEffect(() => {
    fetchConfig();
  }, []);

  const raw = useRemoteConfig('sso_restricted_domains', { cache: false });

  const domains = Array.isArray(raw) ? raw.map(d => d.toLowerCase().trim()) : [];

  function isDomainRestricted(email = '') {
    if (!email.includes('@')) return false;
    const domain = email
      .split('@')[1]
      ?.toLowerCase()
      .trim();
    return domain ? domains.includes(domain) : false;
  }

  return { isDomainRestricted, restrictedDomains: domains };
}

export default useSSORestrictedDomains;
